/* Mboxray. One script for one page, and the same file is also the Web Worker
 * that reads each open mailbox: which half runs is decided by whether
 * `document` exists, as in Regexray (PLAN.md, "Module #3").
 *
 * **It runs once**: `App.razor` adds it from the document (I-83) and enhanced
 * navigation is off site wide, which the page's security policy also depends
 * on. The guard exists because both are one setting away from untrue.
 */

import { serve } from "./worker.js";
import { startApp } from "./app/app.js";

if (typeof document === "undefined") {
  serve(self);
} else if (!window.__mbReader) {
  window.__mbReader = true;
  main();
}

function main() {
  const root = document.querySelector('[data-mb="document"]');

  if (!root) {
    return; // Not this page.
  }

  window.__mbApp = startApp(document);
}
